<app-left-side-nav></app-left-side-nav>
<div class="afterLoginPageContainer m-0">
    <div class="mainContent">
        <div class="innovationsDetails">
            <div class="head">
                <span (click)="goBack()"> <i class="fa-solid fa-arrow-left"></i></span>
                <img src="/assets/images/quest-head.png" alt="Banner Image">
                <p  *ngIf="details.is_voting_active" class="font-weight-600 text-center mb-0">You have voted {{ userContestVoteCount }}/{{
                    maxAllowedVoteCount }} entries</p>
                <p *ngIf="!details.is_voting_active" class="font-weight-600 text-center mb-0">Voting is closed</p>
            </div>
            <div class="video-page">
                <div class="video-wrapper">
                    <video autoplay muted controls playsinline>
                        <source [src]="details.primary_media_url" type="video/mp4" />
                    </video>
                </div>
                <div class="bottom-actions" [ngStyle]="{'backgroundColor': isVoted ? '#fff' : '#008940'}">
                    <button class="voteBtn" [ngClass]="{'voted': isVoted}" (click)="details.is_voting_active && onClickVote(details.encodedId)"
                    [disabled]="!details.is_voting_active">
                        <i class="fa-regular fa-hand-pointer me-1"></i> {{ isVoted ? 'Voted' : 'Vote' }}
                    </button>
                    <span class="download" (click)="downloadFile(details.download_media_url)">
                        <i class="bi bi-download"></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- vote submit Modal -->
<div class="modal fade voting" #SuccessModal tabindex="-1" aria-labelledby="voteSubmitModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="text-end mt-3 me-3">
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close modal"><i class="fa-solid fa-xmark"></i></button>
            </div>
            <div class="modal-body text-center px-4">
                <img src="/assets/images/vote-success.gif" />

                <h4 class="fw-bold text-black my-3">Vote Submitted</h4>
                <p class="text-black">Your vote has been successfully recorded. You’ve used {{ userContestVoteCount }}
                    of {{ maxAllowedVoteCount }} votes</p>
                <button type="button" class="btn mt-3 mb-2" data-bs-dismiss="modal"
                    routerLink="/contests/participants-list">Keep Voting</button>
            </div>
        </div>
    </div>
</div>

<!-- Unvote Modal -->
<div class="modal fade voting" #VoteChangedModal tabindex="-1" aria-labelledby="ChangedModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="text-end me-3">
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close modal"><i class="fa-solid fa-xmark"></i></button>
            </div>
            <div class="modal-body text-center px-4">
                <img src="/assets/images/mind.png" />

                <h4 class="fw-bold text-black mt-2 mb-3">Changed your mind?</h4>
                <p class="text-black">No problem! Just confirming—do you
                    want to take back your vote for this entry?</p>

                <button type="button" class="btn mt-3 mb-2" (click)="callUnVoteEntry(details.encodedId)"
                    data-bs-dismiss="modal">Yes, Remove Vote</button><br>
                <button type="button" class="keep" data-bs-dismiss="modal">Keep Vote</button>
            </div>

        </div>
    </div>
</div>

<!-- Replace voteModal -->
<div class="modal fade voting" tabindex="-1" aria-labelledby="replaceVoteModalLabel" aria-hidden="true"
    #ReplaceVoteModal>
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="text-end me-3">
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close modal"><i class="fa-solid fa-xmark"></i></button>
            </div>
            <div class="modal-body text-center px-4">
                <img src="/assets/images/vote-success.gif" />

                <h4 class="fw-bold text-black mt-2 mb-3">You’ve used all {{ maxAllowedVoteCount }} votes</h4>
                <p class="text-black">Voting for this entry will replace <br>
                    your oldest vote.</p>

                <button type="button" class="btn mt-3 mb-2" (click)="callFetchVoteEntry(details.encodedId, true)"
                    data-bs-dismiss="modal">Yes, Replace Oldest Vote</button><br>
                <button type="button" class="keep" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>